<div *ngIf="!logic || !isClosed"
     [ngClass]="{'pe-countdown':true,'pe-no-margin':item.data.fullWidth}"

     [ngStyle]="{maxWidth:layoutSetting.maxWidth + 'px'}">
  <app-sub-component-container [layoutSetting]="layoutSetting" [item]="item">
    <div class="pe-cta-header">
      {{ item.data.header}}
    </div>
    <div class="pe-cta-description">
      {{item.data.description}}
    </div>
    <div>
      <ul class="pe-countdown-timer">
        <li><span id="days">{{  item.data.countdown.day}}</span>days</li>
        <li><span id="hours">{{  item.data.countdown.hour}}</span>Hours</li>
        <li><span id="minutes">{{  item.data.countdown.min}}</span>Minutes</li>
        <li><span id="seconds">{{  item.data.countdown.sec}}</span>Seconds</li>
      </ul>
    </div>
  </app-sub-component-container>
</div>
<div class="pe-countdown-closed" *ngIf="logic && isClosed && item.data.closeTheStore">
  <div class="pe-c-c-title" [innerHTML]="item.data.textHtml">

  </div>
</div>
